import ValuationResultType from '@/enums/valuation/ValuationResultType';
import Valuation from './Valuation';

export default class ValuationResponse {
  public success: boolean = false;

  public resultType: ValuationResultType = ValuationResultType.Unknown;

  public result: Valuation = new Valuation();
}
